import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../../styles/lead-mangement/lms-followups.css";
import { fetchLMSFollowupsData } from "../../../../redux/prospect-reducers/prospectSlice";
// import FollowupTbDesktop from "../../followup/FollowupTbDesktop";
import FollowupSystemMobile from "../../fully-customised/FollowupSystemMobile";
import PaginationBar from "../lms-customised-comps/PaginationBar";
import FollowupDesktop from "../lms-followups/FollowupDesktop";

const LMSFollowupV2 = ({ userInfoData, rowData, setActiveTab }) => {
  const dispatch = useDispatch();
  const { lmsFollowups, lmsFollowupsLoading, lmsFollowupsError } = useSelector(
    (state) => state.prospects
  );

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    lead_id: rowData?.lead_id,
  };
  const [filters, setFilters] = useState(iniFilters);

  const initialData = {
    data: [],
    pagination: [],
  };
  const [allFollowupsDatas, setAllFollowupsDatas] = useState(initialData);

  const sortedFollowupData =
    allFollowupsDatas?.data?.length > 0
      ? [...allFollowupsDatas.data].sort(
          (a, b) => b?.follow_up_number - a?.follow_up_number
        )
      : [];

  function getLMSFollowups(filters) {
    dispatch(
      fetchLMSFollowupsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    if (filters.lead_id) {
      getLMSFollowups(filters);
    }
  }, [filters]);

  useEffect(() => {
    if (
      !lmsFollowupsLoading &&
      !lmsFollowupsError &&
      lmsFollowups?.status &&
      lmsFollowups?.data
    ) {
      setAllFollowupsDatas((prevs) => ({
        ...prevs,
        data: lmsFollowups.data,
        pagination: lmsFollowups.pagination,
      }));
    } else {
      setAllFollowupsDatas(initialData);
    }
  }, [lmsFollowupsLoading, lmsFollowups]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit,
    }));
  }, [isPage, pageLimit]);

  if (lmsFollowupsLoading) {
    return (
      <div className="lead-v2-cycle-loading">
        <div className="lead-v2-loading-spinner"></div>
        <p>Loading leads...</p>
      </div>
    );
  }

  return (
    <>
      <div className="followup-box lms-followup-v2">
        <div className="only-desktop mb30">
          <FollowupDesktop
            allFollowups={sortedFollowupData || []}
            addFollowup={() => setActiveTab(4)}
            leadStatus={rowData?.lead_status}
          />

          {/* <FollowupTbDesktop
            userInfoData={userInfoData}
            allFollowups={sortedFollowupData || []}
            addFollowup={() => setActiveTab(4)}
            leadStatus={rowData?.lead_status}
          /> */}
        </div>

        <div className="mobile-version-followup mb30">
          <FollowupSystemMobile
            userInfoData={userInfoData}
            rowData={rowData}
            allFollowups={sortedFollowupData || []}
            callFunction={() => {
              getLMSFollowups(filters);
            }}
            isMarketing={userInfoData?.account_type === "marketing"}
            isAdmin={userInfoData?.account_type === "admin"}
          />
        </div>

        {Number(allFollowupsDatas.pagination?.[0]?.pagination || 0) > 10 && (
          <PaginationBar
            isPage={isPage}
            setIsPage={setIsPage}
            paginationArray={allFollowupsDatas.pagination}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>
    </>
  );
};

export default LMSFollowupV2;
